import { h } from '@stencil/core';
import cn from 'classnames';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
const CarouselButton = ({ direction, disabled, onClick }) => {
  return (h("button", { onClick: onClick, class: cn('business-lines-carousel__button', `business-lines-carousel__button--${direction}`, {
      'business-lines-carousel__button--disabled': disabled,
    }) }, h("pes-icon", { class: "business-lines-carousel__button-icon", color: "standard", size: pesIconSizes.SMALL, mirror: direction === "next" ? pesIconMirrorDirection.HORIZONTAL : undefined }, "arrow2_left")));
};
export default CarouselButton;
